import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";

export class AgentVehiclesViewCtrl implements IController {

  agent: AgentModel;

  constructor() {
  }

  $onInit() {

  }

  onVehicleSelect(vehicle) {

  }

  onVehicleRemove(vehicle) {

  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentVehiclesView', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-vehicles-view.html').default,
    controller: AgentVehiclesViewCtrl
  });
